export default __webpack_public_path__ + "images/legend.d5aadfb7fe9844c2749e8b0d1bf0285e.png";